// extracted by mini-css-extract-plugin
module.exports = {"dialog":"MyBankPopup_dialog_2jV7Z","delete":"MyBankPopup_delete_1HLkL"};